import { TranslocoPipe, provideTranslocoScope, translate } from '@jsverse/transloco';
import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatNativeDateModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { CustomerNotes } from '../../../../interfaces/customer-detail-notes.model';

type CustomersNoteDialogData = {
  mode: 'add' | 'edit' | 'view';
  note?: CustomerNotes;
};

@Component({
  providers: [provideTranslocoScope('customers')],
  selector: 'cus-customers-note-dialog-component',
  imports: [TranslocoPipe,
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSlideToggleModule,
  ],
  templateUrl: './customers-note-dialog-component.html',
  styleUrl: './customers-note-dialog-component.scss',
})
export class CustomersNoteDialogComponent {
  noteForm: FormGroup;

  constructor(
    private dialogRef: MatDialogRef<CustomersNoteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) readonly data: CustomersNoteDialogData,
    private formBuilder: FormBuilder,
  ) {
    this.noteForm = this.formBuilder.group({
      data: [{
        value: this.data.note?.data ? new Date(this.data.note.data) : new Date(),
        disabled: this.data.mode !== 'add',
      }],
      titolo: [this.data.note?.titolo ?? '', Validators.required],
      testo: [this.data.note?.testo ?? ''],
      addOrdine: [this.data.note?.addOrdine ?? false],
    });

    if (this.isViewMode) {
      this.noteForm.disable();
    }
  }

  get title() {
    if (this.data.mode === 'edit') {
      return translate<string>('customers.ui.modificaNota');
    }

    if (this.data.mode === 'view') {
      return translate<string>('customers.ui.dettaglioNota');
    }

    return translate<string>('customers.ui.aggiungiNota');
  }

  get isViewMode() {
    return this.data.mode === 'view';
  }

  onClose() {
    this.dialogRef.close();
  }

  onReset() {
    this.noteForm.reset({
      data: {
        value: this.data.note?.data ? new Date(this.data.note.data) : new Date(),
        disabled: this.data.mode === 'edit',
      },
      titolo: this.data.note?.titolo ?? '',
      testo: this.data.note?.testo ?? '',
      addOrdine: this.data.note?.addOrdine ?? false,
    });
  }

  onApply() {
    if (this.noteForm.invalid) {
      this.noteForm.markAllAsTouched();
      return;
    }

    this.dialogRef.close({ action: 'save', value: this.noteForm.getRawValue() });
  }

  onEdit() {
    this.dialogRef.close({ action: 'edit' });
  }
}
